import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";

import Navbar from './Components/Navbar/Navber';
import Footer from './Components/Footer/Footer';
import Home from "./Pages/Home/Home";
import Logins from "./Pages/Login/Login";
import Createprof from "./Pages/Createprofile/Createprof";
// import Result from "./Pages/Results/Result";
import Use from "./Pages/Use/Use";
import Cont from './Components/Contribute/Cont';
import About from './Components/Features/Features.jsx';

const Layout = () =>{
  return(
    <div className='app'>
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  )
};


const router = createBrowserRouter([
    {
      path:"/",
      element:<Layout />,
      children: [
    {
      path:"/",
      element:<Home />
    },
    {
      path:"/login",
      element:<Logins />
    },
    {
      path:"/about",
      element:<About />
    },
     {
      path:"/use",
      element:<Use />
    },
    {
      path:"/cont",
      element:<Cont />
    },
    {
      path:"/creprof",
      element:< Createprof />
    },
  ],},
  ]);

function App() {
  return (
    
    <div className="App">
        <RouterProvider router={router}/>
    </div>

   
  );
}

export default App;
